import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private loggerEnabled() {
    return !!localStorage.getItem('_logger');
  }

  log(message: any, ...optionalParams: any[]) {
    if (!this.loggerEnabled()) return;
    if (!optionalParams || optionalParams.length === 0) {
      console.log(message);
      return;
    }
    console.log(message, optionalParams);
  }

  warn(message: any, ...optionalParams: any[]) {
    if (!this.loggerEnabled()) return;
    if (!optionalParams || optionalParams.length === 0) {
      console.warn(message);
      return;
    }
    console.warn(message, optionalParams);
  }

  error(message: any, ...optionalParams: any[]) {
    if (!this.loggerEnabled()) return;
    if (!optionalParams || optionalParams.length === 0) {
      console.error(message);
      return;
    }
    console.error(message, optionalParams);
  }
}
